import {Type} from 'class-transformer';
import {YascExcelMappingTemplate, YascExcelTemplateItem} from '@yasc/yasc-material-components';

export class ExcelTemplateRes implements YascExcelMappingTemplate {
    id!: number
    name!: string
    @Type(() => ExcelTemplateItemRes)
    templateItems: ExcelTemplateItemRes[] = []

}

export class ExcelTemplateItemRes implements YascExcelTemplateItem {
    id!: number
    objectKey!: string
    excelKey!: string
    default!: string
}

export class ExcelTemplateCreateReq {
    name!: string
    forClass!: string
    @Type(() => ExcelTemplateItemCreateReq)
    itemCreateReq: ExcelTemplateItemCreateReq[] = []

    constructor(template: YascExcelMappingTemplate, forClass: string) {
        this.forClass = forClass
        this.name = template.name
        this.itemCreateReq = template.templateItems.map(x => {
            return new ExcelTemplateItemCreateReq(x)
        })
    }
}

export class ExcelTemplateItemCreateReq {
    objectKey!: string
    excelKey!: string
    default!: string

    constructor(templateItem: YascExcelTemplateItem) {
        this.objectKey = templateItem.objectKey
        this.excelKey = templateItem.excelKey ?? ""
        this.default = templateItem.default ?? ""
    }
}